<template>
<v-container fluid>

  <v-snackbar
    v-model="snackbar"
    :color="snackbarColor"
    :top="true"
    :right="true"
    :timeout="0"
    absolute
    auto-height
  >
    {{ message }}
    <v-btn
      dark
      flat
      @click="snackbar = false"
    >
      CLOSE
    </v-btn>
  </v-snackbar>
<!--<v-snackbar-->
<!--  v-model="snackbar"-->
<!--  :color="snackbarColor"-->
<!--  top-->
<!--  right-->
<!--  :timeout="-1"-->
<!--  >-->
<!--  {{ message }}-->
<!--  <v-btn-->
<!--    dark-->
<!--    text-->
<!--    @click="snackbar = false"-->
<!--  >-->
<!--    CLOSE-->
<!--  </v-btn>-->
 </v-snackbar>
  <v-layout class="mt-14">
  <v-flex xs12>
    <div :class="paginatedFiles.length === 7 ? 'viewfarmer_box' : 'viewfarmer_box_empty'">
      <v-card-text>
    <v-layout>
      <v-flex xs3>
      <span class="accent--text" style="font-size: 14px; font-weight:700;"> Cherry Summary Report </span>
    </v-flex>
    <v-spacer>
    </v-spacer>
    <v-flex xs3>
       <v-text-field label="Search" v-model="search">
       </v-text-field>
     </v-flex>
     </v-layout>
      <table class="table">
         <thead class="thead">
          <tr>
            <th scope="col">Grower Code</th>
            <th scope="col">Season</th>
            <th scope="col">Number of Farmers</th>
            <th scope="col">Total Cherry</th>
            <th scope="col">Status</th>
            </tr>
        </thead>
        <tbody>
        <tr v-for="cherry in filteredList" v-bind:key="cherry.id">
          <td> {{ cherry.growerCode  }} </td>
          <td> {{ cherry.season }} </td>
          <td> {{ cherry.numberOfFarmers }} </td>
          <td>{{ cherry.totalCherry }}</td>
          <td>{{ cherry.status }}</td>
        </tr>
        </tbody>
      </table>
      </v-card-text>
      <v-card-actions>
        <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
        <v-spacer></v-spacer>
        <v-pagination
        v-model="page"
        :length="numberOfLinks"
        color="secondary"
                class="accent--text logoutbtn"
      ></v-pagination>
      </v-card-actions>
    </div>
  </v-flex>
  </v-layout>

</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
	name: 'viewCherryReport',
	data: function () {
		return {
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			cherry: [],
			totalCherry: 0,
			pagination: { sortBy: 'id', descending: true },
			search: '',
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			farmerBankDetail: null,
			editDialog: false,
			bankDetailsDialog: false,
			farmer: { farmerBankDetail: { bank: {} } },
			banks: [],
			permissions: [],
			organisationType: '',
			organisationId: ''
		}
	},
	mounted () {
		this.getLoggedInUser()
		this.getCherryReport()
		this.permissions = store.state.user.roleId.permissions
	},
	watch: {
		cherry () {
			this.paginatedFiles = this.paginationMethod(this.cherry, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.cherry.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.cherry, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.cherry.filter(chery => { return (chery.growerCode !== null ? chery.growerCode.toLowerCase().includes(this.search.toLowerCase()) : ''.toLowerCase().includes(this.search.toLowerCase())) || (chery.season === null ? ''.toLowerCase().includes(this.search.toLowerCase()) : chery.season.toLowerCase().includes(this.search.toLowerCase())) || chery.status.includes(this.search) })
			}
		}
	},
	methods: {
		getLoggedInUser () {
			this.theUser = JSON.parse(localStorage.getItem('user'))
			console.log('user ===>> ', this.theUser)
			this.organisationType = this.theUser.organisation.organisationType.name
			this.organisationId = this.theUser.organisation.id
			// this.curUserN = this.curUser.firstName
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		getCherryReport () {
			const url = config.serverURI + '/upload/cherry/summaryReport/' + this.organisationId
			axios.get(url)
				.then(response => {
					this.cherry = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		}
	}
}

</script>
<style>
.viewfarmer_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.viewfarmer_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.catalogue_box:after, .catalogue_box:before {
  right: 100%;
  top: 17%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogue_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}
.catalogue_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table  tbody  tr >  td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}
.pagination {
  background-color: red;
}
.paginationtext {
  color: #733D29;
}

.pagination>li>a,
.pagination>li>span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}
.pagination>li.active>.page-link {
  background: #00513B;
  color: #fff;
}
</style>
